import { useState } from 'react';

const useDateNow = () => {
  const [dateNow] = useState(() => Date.now());

  return { dateNow };
};

export default useDateNow;
